import { useAuthStore } from '@stores/auth'

// Base URL de la API
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/api/"

/**
 * Interceptor de autenticación para agregar token a las requests
 */
const authInterceptor = {
  request: (config) => {
    // Obtener el token del store de Zustand
    const authToken = useAuthStore.getState().authToken;

    if (!config.skipInterceptor && authToken) {
      config.headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        ...config.headers
      }
      
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }
    }
    
    config.baseURL = API_BASE_URL;
    return config;
  },
  
  requestError: (error) => Promise.reject(error)
}

/**
 * Interceptor de loading para mostrar/ocultar indicador global
 */
const loadingInterceptor = {
  request: (config) => {
    // Mostrar indicador de carga global
    document.body.classList.add('loading-indicator');
    return config;
  },
  
  requestError: (error) => {
    document.body.classList.remove('loading-indicator');
    return Promise.reject(error);
  },
  
  response: (response) => {
    // Ocultar indicador de carga global
    document.body.classList.remove('loading-indicator');
    return response;
  },
  
  responseError: (error) => {
    document.body.classList.remove('loading-indicator');
    return Promise.reject(error);
  }
}

/**
 * Configurar interceptors de axios
 * @param {Object} axios - Instancia de axios
 */
export default function setupAxios(axios) {
  // Interceptor de autenticación
  axios.interceptors.request.use(
    authInterceptor.request,
    authInterceptor.requestError
  );

  // Interceptor de loading
  axios.interceptors.request.use(
    loadingInterceptor.request,
    loadingInterceptor.requestError
  );

  axios.interceptors.response.use(
    loadingInterceptor.response,
    loadingInterceptor.responseError
  );
}

// Exportar configuraciones para uso en otros lugares si es necesario
export { API_BASE_URL, authInterceptor, loadingInterceptor }; 